import React, { createContext, useContext } from "react";
import { Tooltip, type TooltipProps } from "@shopify/polaris";

const DemoModeContext = createContext<boolean>(false);

export const DemoModeProvider: React.FC<{ isDemoMode: boolean; children: React.ReactNode }> = ({ isDemoMode, children }) => (
  <DemoModeContext.Provider value={isDemoMode}>{children}</DemoModeContext.Provider>
);

export const useIsDemoMode = () => useContext(DemoModeContext);

interface TooltipDemoOnlyProps extends TooltipProps {
  persist?: boolean;
}

export const TooltipDemoOnly: React.FC<TooltipDemoOnlyProps> = ({ persist, ...props }) => {
  // Only show tooltips if explicitly persisted.
  if (!persist) return <>{props.children}</>;
  return <Tooltip {...props} />;
};
